import { useEffect, useState } from 'react'
import { getProcessingFeesFromPricing, PaymentMethodType } from '@genoa/domain'
import { PaymentSchedule } from '@genoa/middle-end'

import { useCustomerWalletState, usePricingOfferState } from '../../../../../../modules/flex2/use-state'
import { usePaymentItems } from './useBalanceOutOfRangePaymentItems'

export const usePaymentSchedule = (
  paymentSchedule: PaymentSchedule[],
  skipFees: boolean,
  defaultProcessingFee: number = 0
) => {
  const [processingFeePercentage, setProcessingFeePercentage] = useState(defaultProcessingFee)

  const pricingOfferState = usePricingOfferState()
  const customerWalletState = useCustomerWalletState()

  useEffect(() => {
    if (!pricingOfferState.initialized || !customerWalletState.initialized) {
      return
    }

    const defaultCard = customerWalletState?.defaultCard
    const pricingProcessingFees = getProcessingFeesFromPricing(pricingOfferState.pricing_offer)
    const newProcessingFeePercentage =
      defaultCard?.card_type === PaymentMethodType.CREDIT ? pricingProcessingFees.credit : pricingProcessingFees.debit

    setProcessingFeePercentage(newProcessingFeePercentage)
  }, [pricingOfferState, customerWalletState])

  const paymentItems = usePaymentItems({
    processingFeePercentage,
    payments: paymentSchedule,
    skipFees,
  })

  return { paymentItems, processingFeePercentage }
}
